// Import libs
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import QueryString from 'query-string';

// Import assets
import './articleView.scss';

// Import components
import Meta from '../../Components/Globals/Meta/MetaController';
import TextModule from '../../Components/Modules/TextModule/TextModuleView';
import StageModule from '../../Components/Modules/StageModule/StageModuleView';
import QuoteModule from '../../Components/Modules/QuoteModule/QuoteModuleView';
import HeadlineModule from '../../Components/Modules/HeadlineModule/HeadlineModuleView';
import InterviewModule from '../../Components/Modules/InterviewModule/InterviewModuleView';
import CompareImagesModule from '../../Components/Modules/CompareImagesModule/CompareImagesModuleView';
import TeaserModule from '../../Components/Modules/TeaserModule/TeaserModuleController';
import AuthorModule from '../../Components/Modules/AuthorModule/AuthorModuleView';
import TagModule from '../../Components/Modules/TagModule/TagModuleView';
import { setLang } from '../../Base/Actions/globalActions';
import { fetchArticle } from '../../Base/Actions/articleActions';
import ImageWithTextView from '../../Components/Modules/ImageWithTextModule/ImageWithTextModuleView';
import ImageSliderView from '../../Components/Modules/ImageSliderModule/ImageSliderModuleView';
import HTMLModuleView from '../../Components/Modules/HTMLModule/HTMLModuleView';
import GridImagesModuleView from '../../Components/Modules/GridImagesModule/GridImagesModuleView';
import VideoModuleView from '../../Components/Modules/VideoModule/VideoModuleView';
import DateSharingModuleView from '../../Components/Modules/DateSharingModule/DateSharingModuleView';
import ProductController from '../../Components/Modules/ProductSliderModule/ProductController';
import LenspireView from '../LenspireView';

class ArticleView extends React.Component {
  static determinModuleType(moduleData, lang) {
    switch (moduleData.type) {
      case 'author':
        return (<AuthorModule
          key={moduleData.id}
          {...moduleData.data}
        />);
      case 'headline':
        return (<HeadlineModule priority={moduleData.data.priority} biggerSpacing={moduleData.data.moreSpace}>{moduleData.data.text}</HeadlineModule>);
      case 'text':
        return (<TextModule key={moduleData.id}>{moduleData.data.content}</TextModule>);
      case 'compareimages':
        return (<CompareImagesModule
          key={moduleData.id}
          images={moduleData.data.images}
        />);
      case 'grid':
        return (<GridImagesModuleView
          key={moduleData.id}
          images={moduleData.data.images}
        />);
      case 'image':
        return (<CompareImagesModule
          key={moduleData.id}
          images={[moduleData.data]}
        />);
      case 'quote':
        return (<QuoteModule key={moduleData.id} cited={moduleData.data.author}>{moduleData.data.content}</QuoteModule>);
      case 'interview':
        return (<InterviewModule
          key={moduleData.id}
          pairs={moduleData.data.pairs}
        />);
      case 'stage':
        return (<StageModule
          key={moduleData.id}
          {...moduleData.data}
        />);
      case 'imgtext':
        return (<ImageWithTextView
          key={moduleData.id}
          {...moduleData.data}
        />);
      case 'slideshow':
        return (<ImageSliderView
          images={moduleData.data.images}
        />);
      case 'tags':
        return (<TagModule
          key={moduleData.id}
          tags={moduleData.data.tags}
          lang={lang}
        />);
      case 'teaser':
        return (<TeaserModule
          key={moduleData.id}
          headline={'More from the author:'}
          articles={moduleData.data.articles}
        />);
      case 'markup':
        return (<HTMLModuleView>
          <div className={'m-markup-module'} dangerouslySetInnerHTML={{ __html: moduleData.data.markup }} />
        </HTMLModuleView>);
      case 'video':
        return (<VideoModuleView
          {...moduleData.data}
        />);
      case 'dateAndSharing':
        return (<DateSharingModuleView
          key={moduleData.id}
          {...moduleData.data}
        />);
      case 'productSlider':
        return (<ProductController
          key={moduleData.id}
          {...moduleData.data}
        />);
      default:
        return null;
    }
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    const hash = QueryString.parse(this.props.location.hash);
    this.props.fetchArticle(this.props.match.params.lang, { slug: this.props.match.params.article, _wpnonce: hash.preview, tmppreview: hash.tmppreview });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params !== this.props.match.params) {
      window.scrollTo(0, 0);
      this.props.fetchArticle(nextProps.match.params.lang, { slug: nextProps.match.params.article });
    }
  }

  render() {
    const { article } = this.props;
    const modules = article.map(moduleData => (
      <section key={moduleData.id} id={moduleData.id}>
        {ArticleView.determinModuleType(moduleData, this.props.lang)}
      </section>
    ));

    return (
      <LenspireView {...this.props} className={'o-article'}>
        <Meta />
        <div className="o-article__content">
          {!this.props.isLoading ? modules : null}
        </div>
      </LenspireView>
    );
  }
}

function mapStateToProps(state) {
  return {
    lang: state.globalsState.lang,
    article: state.articleState.article,
    error: state.globalsState.error,
    isLoading: state.loaderState.isLoading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setLang, fetchArticle }, dispatch);
}

ArticleView.propTypes = {
  match: PropTypes.shape().isRequired,
  location: PropTypes.shape().isRequired,
  setLang: PropTypes.func.isRequired,
  fetchArticle: PropTypes.func.isRequired,
  article: PropTypes.arrayOf(PropTypes.shape()),
  error: PropTypes.string,
  lang: PropTypes.string,
  isLoading: PropTypes.bool,
};

ArticleView.defaultProps = {
  article: [],
  error: '',
  lang: 'en',
  isLoading: true,
};

export default connect(mapStateToProps, mapDispatchToProps)(ArticleView);



// WEBPACK FOOTER //
// ./frontend/js/Views/ArticleView/ArticleView.jsx